import fetch from "../utils/fetch";

//查询领取规则
export const fetchGetRules = (params) =>
  fetch(`rule/receive`, {
    method: "get",
    params,
  });

//设置领取规则
export const fetchSetRules = (data) => {
  return fetch(`/rule/receive`, {
    method: "put",
    data,
  });
};

//查询积分规则
export const fetchIntegraRules = () => fetch(`/rule/integral`);

//设置积分规则
export const fetchSetIntegraRules = (data) =>
  fetch(`/rule/integral`, {
    method: "put",
    data,
  });

//查询测评规则
export const fetchEvaluationRules = () => {
  return fetch(`/evaluation/rule`);
};

//编辑测评规则
export const fetchEditEvaluationRules = (data) => {
  return fetch(`/evaluation/rule`, {
    method: "put",
    data,
  });
};

//查询ai开关
export const fetchAISet = () => fetch(`/rule/receive/ai`);

//设置AI开关
export const fetchSetAI = (open) =>
  fetch(`/rule/receive/ai/${open}`, {
    method: "put",
  });
